import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW9007Model } from './kymw9007.model';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { Router } from '@angular/router';
import { SendPasswordResetEmailService } from './api-services/send-password-reset-email.service'
import { PlessAlert } from '../../../shared/pless-alert/pless-alert.component';

/**
 * パスワード再設定画面
 *
 * @export KYMW9007Component
 * @class KYMW9007Component
 */
@Component({
  selector: 'app-kymw9007',
  templateUrl: 'kymw9007.component.html',
  styleUrls: ['kymw9007.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW9007Component extends PlessViewHelperSub implements OnInit {

  public model: KYMW9007Model = new KYMW9007Model();

  /**
   *Creates an instance of KYMW9007Component.
   * @param {KYMW00Model} kymw00Model
   * @param {Router} router
   * @param {SendPasswordResetEmailService} SendEmailService
   * @param {PlessDialogServiceSub} dialogService
   * @memberof KYMW9007Component
   */
  constructor(
    public kymw00Model: KYMW00Model,
    private router: Router,
    private SendEmailService: SendPasswordResetEmailService,
    private dialogService: PlessDialogServiceSub,
    ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW9007Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW9007';
  }

  /**
   * 戻るボタンを押した時のイベント
   * 
   * @memberof KYMW9007Component
   */
  public eventReturnHanler(): void {
    this.router.navigate(['/login']);
  }

  /**
   * 送信ボタンを押した時のイベント
   * 
   * @memberof KYMW9007Component
   */
  public eventSendPassResetEmailHandler(): void {
    this.SendEmailService.execute(this.model, () => {
      this.dialogService.openAlertGetMessage('I0512', [], (closeDetail: any): void => {
        if (closeDetail === PlessAlert.Yes) {
          this.router.navigate(['/kymw/9011']);
        }
      });
    });
  }
}
